function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerbi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 3.9472,
    x2: 32,
    y2: 44.7512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0056,
    style: {
      stopColor: "#EBB112"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BB5C17"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M27,44h10c1.105,0,2-0.895,2-2V6c0-1.105-0.895-2-2-2H27c-1.105,0-2,0.895-2,2v36 C25,43.105,25.895,44,27,44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0886,
    y1: 13.1404,
    x2: 26.0093,
    y2: 45.6723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED35D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2808,
    style: {
      stopColor: "#F6C648"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8568,
    style: {
      stopColor: "#E3A513"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9888,
    style: {
      stopColor: "#DE9D06"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M19,44h10c1.105,0,2-0.895,2-2V16c0-1.105-0.895-2-2-2H19c-1.105,0-2,0.895-2,2v26 C17,43.105,17.895,44,19,44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.8026,
    y1: 22.7811,
    x2: 21.3352,
    y2: 43.6582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD869"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9832,
    style: {
      stopColor: "#FFDF26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M11,44h10c1.105,0,2-0.895,2-2V26c0-1.105-0.895-2-2-2H11c-1.105,0-2,0.895-2,2v16 C9,43.105,9.895,44,11,44z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerbi);
export default __webpack_public_path__ + "static/media/powerbi.74ee590ab7a425f93f6c907f60ab8077.svg";
export { ForwardRef as ReactComponent };